import z from "zod";
import type { Context } from "hono";

export const restoreVersionRequestBodySchema = z.object({
  messageId: z.string(),
  commitSha: z.string(),
});

export type RestoreVersionRequestBody = z.infer<
  typeof restoreVersionRequestBodySchema
>;

export type RestoreVersionResponseBody = {
  success: boolean;
};

export type RestoreVersionHandlerReturnType = Promise<
  ReturnType<
    typeof Context.prototype.json<
      | RestoreVersionResponseBody
      | { error: string }
      | { errors: z.ZodIssue[] }
      | string
    >
  >
>;
